import { get, set } from 'object-path';
const arrayRegex = new RegExp(/(\[[\d.?]\])/gm);

type ParamMap = {
    path?: string;
    key?: string;
    defaultValue?: string | null;
};

type ParamConfig = {
    parent?: string;
    paramMapping: ParamMap[];
};

const getParamsFromObject = (params: object = {}, config: ParamConfig) => {
    const ret = {};
    if (config) {
        const { parent, paramMapping } = config;
        if (paramMapping && paramMapping.length && params && Object.keys(params).length !== 0) {
            paramMapping.forEach((param: ParamMap) => {
                const { path, key, defaultValue } = param;

                if (path && key) {
                    let item;
                    const regexMatch = path.match(arrayRegex);
                    if (regexMatch && regexMatch.length > 0) {
                        item = getArrayItem(regexMatch[0], path, params, parent, defaultValue);
                    } else if (parent) {
                        item = get(params, `${parent}.${path}`, defaultValue);
                    } else {
                        item = get(params, path, defaultValue);
                    }
                    if (typeof item !== 'undefined') {
                        set(ret, key, item);
                    }
                }
            });
        }
    } else {
        Object.assign(ret, { ...params });
    }

    return ret;
};

const getArrayItem = (
    regexMatch: string,
    path: string,
    params: ParamMap,
    parent?: string,
    defaultValue?: string | null,
) => {
    const splitPath = path.split(regexMatch);
    if (splitPath && splitPath.length) {
        const firstHalf = splitPath[0];
        const beforeArray = parent
            ? get(params, `${parent}.${firstHalf}`, [])
            : get(params, firstHalf, []);

        if (beforeArray && beforeArray.length > 0) {
            const arrayIndexed = beforeArray![JSON.parse(regexMatch)[0]];
            if (splitPath.length > 1) {
                return get(arrayIndexed, splitPath[1], defaultValue);
            } else {
                return arrayIndexed;
            }
        }
    }
};

export { getParamsFromObject };
